var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heatmap-loader loading",attrs:{"title":"Loading map..."}},[(true)?_c('v-progress-circular',{staticClass:"heatmap-loader__progress",attrs:{"indeterminate":"","color":"primary","size":"25"}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-652f7197","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./frontend/src/components/heatmap/HeatmapLoader.vue
// module id = null
// module chunks = 